<template>
  <div :title="qaAble ? showIfHasPermission?.toString() : null" v-if="showComponent">
    <template v-if="defaultViewType == 'modal'">
      <ks-modal
        :ref="`inputfileSelectorModal${_uid}`"
        position="centered"
        :title="modalTitle"
        :modalWidth="`${modalWidth}`"
        :backdropClose="false"
        :enableClose="true"
      >
        <ks-modal-body>
          <ks-file-selector
            :ref="`ifs-file-selector-${_uid}`"
            :primaryFile="file"
            :defaultFilters="defaultFilters"
            :uploadOptions="uploadOptions"
            :showDefaultNavigation="false"
            @onChange="change"
            @onUploaderChangeMode="uploaderChangeMode"
            @onUploadLoading="uploadLoading"
            @onChangeUploadFiles="changeUploadFiles"
          />
        </ks-modal-body>

        <ks-modal-footer>
          <template v-if="mode == 'default'">
            <ks-button :disabled="disableAccept" @onClick="accept()" label="Accept" classIcon="fas fa-check" />

            <ks-button color="danger" @onClick="close()" label="Cancel" classIcon="fas fa-ban" />
          </template>

          <template v-else-if="mode == 'upload' || mode == 'edit'">
            <ks-button
              v-show="!isUploadLoading"
              @onClick="execUpload()"
              :label="`Upload ${uploaderFilesLength > 1 ? '(all)' : ''}`"
              classIcon="fa fa-upload"
            />
            <ks-button
              v-show="isUploadLoading"
              :disabled="true"
              :label="`Upload ${uploaderFilesLength > 1 ? '(all)' : ''}`"
              classIcon="fas fa-spinner fa-pulse"
            />

            <ks-button v-if="mode == 'edit'" class="ml-2" color="secondary" @onClick="execCloseEdit()" label="Close Edit" classIcon="fa fa-times" />

            <ks-button v-else class="ml-2" color="danger" @onClick="execCancel()" label="Cancel" classIcon="fa fa-ban" />
          </template>
        </ks-modal-footer>
      </ks-modal>

      <div style="display: flex; flex-direction: column" @click="open()" :style="{ width: width, height: height }">
        <span class="mb-2" v-if="label">{{ label }}</span>
        <img
          :src="file._src"
          :class="[{ 'input-file-selector-img': !disabled, 'input-file-selector-img-disabled': disabled }]"
          width="100%"
          height="100%"
          classIcon="fas fa-file-upload"
        />
        <small style="cursor: pointer; text-align: center" class="text-muted" v-if="buttonLabel">{{ buttonLabel }}</small>
      </div>
    </template>
    <template v-else>
      <ks-file-selector
        :primaryFile="file"
        :defaultFilters="defaultFilters"
        :uploadOptions="uploadOptions"
        :showDefaultNavigation="showDefaultNavigation"
        @onChange="change"
      />
    </template>
  </div>
</template>

<script>
  import checkPermissions from '../../mixins/checkPermissions';
  import getSRCThumbnail from '../../mixins/getSRCThumbnail';
  const emptyFile = { campaign_id: null, id: null, _src: require('ks_app/src/assets/images/not-found.jpg') };
  export default {
    name: 'input-file-selector',
    mixins: [checkPermissions, getSRCThumbnail],
    props: {
      label: {
        type: String,
        default: null,
      },
      buttonLabel: {
        type: String,
        default: 'Choose a File',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      modalTitle: {
        type: String,
        default: 'Choose a File',
      },
      modalWidth: {
        type: Number,
        default: 75,
      },
      width: {
        type: String,
        default: '55px',
      },
      height: {
        type: String,
        default: '55px',
      },
      index: {
        type: Number,
        default: null,
      },
      dataSource: {
        type: String,
        required: true,
      },
      campaignId: {
        type: Number,
        required: true,
      },
      defaultValue: {
        default: null,
      },
      defaultFilters: {
        type: Object,
        default: () => {},
      },
      uploadOptions: {
        type: Object,
        default: () => {},
      },
      defaultViewType: {
        type: String,
        default: 'modal',
      },
      showDefaultNavigation: {
        type: Boolean,
        default: true,
      },
    },
    watch: {
      input(val) {
        console.log(val);
        this.loadFile();
      },
    },
    computed: {
      qaAble: {
        get: () => {
          return app.store.state.ks_app.global_data.qaAble;
        },
      },
      dataProviderName() {
        return this.$parent.dataProvider;
      },
      input: {
        get() {
          if (this.dataSource == null) return this.l_input;
          if (this.inputType === 'list') {
            return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
          } else {
            return this.$parent.data_provider_ref[this.inputType][this.dataSource];
          }
        },
        set(newval) {
          if (this.dataSource !== null) {
            if (this.inputType === 'list') {
              this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
            } else {
              this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
            }
          } else {
            this.l_input = newval;
          }
        },
      },
      inputType() {
        return this.$parent.type;
      },
      auth() {
        return app.auth;
      },
      disableAccept() {
        return !this.selectedFile.id || this.selectedFile.id == this.file.id;
      },
    },
    methods: {
      async loadFile() {
        try {
          if (this.input) {
            const res = await app.data.read('file.file', { campaign_id: this.campaignId, file_id: this.input });
            const file = res.read[0];
            this.file = { ...file, _src: this.getSRCThumbnail(file, true) };
          } else {
            this.file = JSON.parse(JSON.stringify(emptyFile));
          }
        } catch (err) {
          this.file = JSON.parse(JSON.stringify(emptyFile));
          console.log(err);
        }
      },
      open() {
        this.selectedFile = {};
        if (!this.disabled) this.$refs[`inputfileSelectorModal${this._uid}`].show();
      },
      close(restore = true) {
        if (restore) this.input = this.bckInput;
        this.selectedFile = {};
        this.$refs[`inputfileSelectorModal${this._uid}`].close();
      },
      change({ file }) {
        this.selectedFile = file;
      },
      accept() {
        this.input = this.selectedFile.id;
        this.close(false);
        this.$emit('onAccept', this);
      },
      validate_input() {
        return true;
      },
      uploaderChangeMode({ mode }) {
        this.mode = mode;
      },
      uploadLoading({ uploadLoading }) {
        this.isUploadLoading = uploadLoading;
      },
      changeUploadFiles({ files }) {
        this.uploaderFilesLength = files.length;
      },

      /* upload file actions */
      execUpload() {
        this.$refs[`ifs-file-selector-${this._uid}`].execUpload();
      },
      execCloseEdit() {
        this.$refs[`ifs-file-selector-${this._uid}`].execCloseEdit();
      },
      execCancel() {
        this.$refs[`ifs-file-selector-${this._uid}`].execCancel();
      },
    },
    mounted() {
      this.id = this._uid;
      if (this.defaultValue !== null) {
        this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, this.defaultValue);
      }
      this.loadFile();
      setTimeout(() => {
        app.dataproviders[this.dataProviderName].inputs[this.dataSource] = this;
        this.bckInput = this.input;
        this.$emit('onMounted', this);
      }, 500);
    },
    data() {
      return {
        file: JSON.parse(JSON.stringify(emptyFile)),
        selectedFile: {},
        l_input: null,
        bckInput: null,
        isUploadLoading: false,
        mode: 'default',
        uploaderFilesLength: 0,
      };
    },
  };
</script>

<style>
  .input-file-selector-img {
    max-width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .input-file-selector-img-disabled {
    max-width: 100%;
    height: 100%;
  }

  .input-file-selector-img:hover {
    opacity: 0.2;
    transition: 0.5s ease;
    background-color: rgba(0, 0, 0, 0.23);
  }
</style>
